import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ResumeExtractionHistory } from '@/features/admin/resume-extraction-playground/history'

const historySearchSchema = z.object({
  page: z.number().optional().catch(1),
})

export const Route = createFileRoute(
  '/_authenticated/admin/resume-extraction-playground/history'
)({
  validateSearch: historySearchSchema,
  component: ResumeExtractionHistory,
})
